/**
 * @generated SignedSource<<1064a3597fdb3478e960cc1f90188a3b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SettingLanguage = "en" | "es" | "fr" | "%future added value";
export type SettingUpdateLanguageInput = {
  clientMutationId?: string | null | undefined;
  initializeIfUnset: boolean;
  language: SettingLanguage;
};
export type GlobalContextProviderSettingUpdateLanguageMutation$variables = {
  input: SettingUpdateLanguageInput;
};
export type GlobalContextProviderSettingUpdateLanguageMutation$data = {
  readonly settingUpdateLanguage: {
    readonly errors: ReadonlyArray<{
      readonly messages: ReadonlyArray<string>;
      readonly path: string;
    }>;
    readonly setting: {
      readonly language: SettingLanguage | null | undefined;
    } | null | undefined;
  };
};
export type GlobalContextProviderSettingUpdateLanguageMutation = {
  response: GlobalContextProviderSettingUpdateLanguageMutation$data;
  variables: GlobalContextProviderSettingUpdateLanguageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messages",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalContextProviderSettingUpdateLanguageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SettingUpdateLanguagePayload",
        "kind": "LinkedField",
        "name": "settingUpdateLanguage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Setting",
            "kind": "LinkedField",
            "name": "setting",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "GlobalContextProviderSettingUpdateLanguageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SettingUpdateLanguagePayload",
        "kind": "LinkedField",
        "name": "settingUpdateLanguage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Setting",
            "kind": "LinkedField",
            "name": "setting",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Error",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6eee2d53da551286e3ba93b0ca97b959",
    "id": null,
    "metadata": {},
    "name": "GlobalContextProviderSettingUpdateLanguageMutation",
    "operationKind": "mutation",
    "text": "mutation GlobalContextProviderSettingUpdateLanguageMutation(\n  $input: SettingUpdateLanguageInput!\n) {\n  settingUpdateLanguage(input: $input) {\n    setting {\n      language\n      id\n    }\n    errors {\n      path\n      messages\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c65ef9b44bf77980efc46d45997aae49";

export default node;
